/**
 * The API's answer for an account with no company: 404 "Company not found"
 * (the dashboard and state-tax landing reads). Both the status and the message
 * must match, so a 404 from a route the deployed Worker does not have yet
 * (version skew) still reads as the failure it is.
 */
export function isCompanyNotFoundError(error: unknown): boolean {
  if (!(error instanceof Error)) return false
  const status = (error as { status?: unknown }).status
  return status === 404 && /company not found/i.test(error.message)
}
